logs-jump
  div.form-inline
    select(class="form-control")
      option &nbsp;
      option(each="{ item in orders }" value="{ item.id }") [ JOBNo.{ item.job_no } ] { item.client_name }
    span &nbsp;へジャンプ
  script(type="typescript").
    this.mixin('logs.jump')
  style(scoped).
    :scope { display: inline-block; }
